import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.state';
import { IUser } from '../model/user.model';
import { AppState } from '../../core/store/core.state';

//export const selectUserState = createFeatureSelector<UserState>('user');
export const selectUserState = (state: AppState) => state.user;

export const selectErrorSelector = createSelector(
  selectUserState,
  (state) => state.authenticationError
);

export const getUserSelector = createSelector(
    selectUserState,
    (state) => state.user
);

export const isAuthenticatedSelector = createSelector(
  selectUserState,
  (state) => state.isAuthenticated
);

export const authenticationErrorSelector = createSelector(
  selectUserState,
  (state) => state.authenticationError
);

export const getUserPictureSelector = createSelector(
  selectUserState,
  (state) => state.user.pictureUrl
);

export const retryLoginErrorSelector = createSelector(
  selectUserState,
  (state) => state.retryLoginError
);

